import { api } from '../index.js'
import { debounce } from 'lodash'
import shortid from 'shortid'

const debouncePreviewTime = 2000

export default {
  namespaced: true,

  state: {
    document: null,
    previewHtml: '',
    subject: '',
    previewSubject: '',
    substitutionErrors: [],
    resourceType: null,
    resourceId: null,
    previewLoaders: [],
    rawMode: false
  },

  mutations: {
    updateMode(state, mode) {
      state.rawMode = mode
    },
    updateDocument(state, doc) {
      state.document = doc
    },

    updatePreviewHtml(state, html) {
      state.previewHtml = html
    },

    updateSubject(state, subject) {
      state.subject = subject
    },

    updatePreviewSubject(state, subject) {
      state.previewSubject = subject
    },

    updateSubstitutionErrors(state, errors) {
      state.substitutionErrors = errors
    },

    resetSubstitutionErrors(state) {
      state.substitutionErrors = []
    },

    addPreviewLoader(state, id) {
      state.previewLoaders.push(id)
    },

    removePreviewLoader(state, id) {
      let index = state.previewLoaders.indexOf(id)
      if (index > -1) {
        state.previewLoaders.splice(index, 1)
      }
    },

    updateResource(state, { resourceType, resourceId }) {
      state.resourceType = resourceType
      state.resourceId = resourceId
    },

    resetResource(state) {
      state.resourceType = null
      state.resourceId = null
    }
  },

  getters: {
    previewLoading(state) {
      return state.previewLoaders.length > 0
    }
  },

  actions: {
    async updatePreview({ commit, state }) {
      if(!state.rawMode){
        const id = shortid.generate()
        commit('addPreviewLoader', id)

        /* eslint-disable no-multi-spaces */
        const resourceType = state.resourceType // may be undefined
        const resourceId   = state.resourceId // may be undefined
        const body    = state.document.render()
        const subject = state.subject
        /* eslint-enable no-multi-spaces */

        // if we're previewing with an application or contact, do a round trip to the server
        if (resourceType && resourceId) {
          try {
            const [results] = await api.emails.preview(subject, body, resourceType, resourceId)
            if (results.body) {
              commit('updatePreviewHtml', results.body)
              commit('updatePreviewSubject', results.subject)
            }

            commit('resetSubstitutionErrors')

            if (results.merge_results && results.merge_results.length > 0) {
              const errors = results.merge_results[0].merge_attributes.reduce((acc, attr) => {
                if ('error' in attr) {
                  acc.push(attr)
                }
                return acc
              }, [])

              commit('updateSubstitutionErrors', errors)
            }
          } catch (err) {
            // ignore promise cancellations, rethrow everything else
            if (err.message !== 'PromiseCancelled') {
              throw err
            }
          }
          // otherwise short circuit and display the body and subject with no substitutions
        } else {
          commit('updatePreviewHtml', body)
          commit('updatePreviewSubject', subject)
          commit('resetSubstitutionErrors')
        }

        commit('removePreviewLoader', id)
      }
    },

    debouncePreview: debounce(function({ commit, state, dispatch }, params) {
      dispatch('updatePreview', params)
    }, debouncePreviewTime, { leading: true }),

    preview({ commit, state, dispatch }, params) {
      dispatch('debouncePreview', params)
    }
  }
}
